<template>
    <EstudianteEditar />
</template>
<script>
import EstudianteEditar from "@/components/EstudianteEditarAdmin.vue";
export default({
     components:{
        EstudianteEditar
    }
})
</script>